import { render, staticRenderFns } from "./ManageCapabilitiesModal.vue?vue&type=template&id=e1b6c992&"
import script from "./ManageCapabilitiesModal.vue?vue&type=script&lang=js&"
export * from "./ManageCapabilitiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports